import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { setPreparationTimeFormSchema } from './set-preparation-time-form.schema';
import { useEffect } from 'react';

export const useSetPreparationTimeForm = selectedEvent => {
  const form = useForm({
    resolver: yupResolver(setPreparationTimeFormSchema),
    defaultValues: setPreparationTimeFormSchema.cast(selectedEvent ?? {}),
  });

  const { reset } = form;
  useEffect(() => {
    reset(selectedEvent ?? {});
  }, [reset, selectedEvent]);

  return { form };
};
